import { useGrowlStoreActions } from "PFApp/stores/growl_store";
import { DropdownButton } from "PFComponents/dropdown_button";
import { Icon } from "PFComponents/icon";
import { useActivityEconomicsScenarioUnassign } from "PFCore/hooks/queries/activity";
import { EconomicsVacancy, Id } from "PFTypes";
import { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";

type VacancyActionsProps = {
  vacancy: EconomicsVacancy;
  scenarioId: Id;
  disabled?: boolean;
  onDelete?: (vacancyId: Id) => void;
};

export const VacancyActions = ({ vacancy, scenarioId, disabled, onDelete }: VacancyActionsProps) => {
  const { showGrowl } = useGrowlStoreActions();
  const { t } = useTranslation("activities", { keyPrefix: "scenario" });

  const { mutate: unassign } = useActivityEconomicsScenarioUnassign(scenarioId);

  const handleDelete = useCallback(() => {
    unassign(vacancy.assignment!.id, {
      onSuccess: () => {
        onDelete?.(vacancy.id);
        showGrowl({
          kind: "success",
          message: t("unassignSuccess")
        });
      },
      onError: () => {
        showGrowl({
          kind: "error",
          message: t("unassignError")
        });
      }
    });
  }, [unassign, vacancy.assignment, vacancy.id, onDelete, showGrowl, t]);

  const options = useMemo(
    () => [{ id: "remove", displayElement: t("remove"), item: handleDelete }],
    [t, handleDelete]
  );

  return (
    <DropdownButton
      options={options}
      buttonKind="blank"
      buttonStyle={{ height: 18 }}
      style={{ marginLeft: "auto" }}
      handleChange={(fn) => fn && fn(vacancy)}
      disabled={disabled}
    >
      <Icon name="menu-vertical" size="md" />
    </DropdownButton>
  );
};
